export const REQUISITE_FIELD_RULES = {
    full_name: { label: "Ф.И.О.", maxLength: 300 },
    passport_series: { label: "Серия паспорта", digits: 4 },
    passport_number: { label: "Номер паспорта", digits: 6 },
    passport_issued_by: { label: "Кем выдан паспорт", maxLength: 2000 },
    passport_department_code: { label: "Код подразделения", digits: 6 },
    registration_address: { label: "Адрес регистрации", maxLength: 2000 },
    actual_residence_address: { label: "Фактический адрес проживания", maxLength: 2000 },
    snils_number: { label: "СНИЛС", digits: 11 },
    inn_number: { label: "ИНН", digits: 12 },
    bank_account: { label: "Расчётный счёт", digits: 20 },
    bank_name: { label: "Название банка", maxLength: 300 },
    bank_bik: { label: "БИК", digits: 9 },
    correspondent_account: { label: "Корреспондентский счёт", digits: 20 },
};

export function digitsOnly(value) {
    return String(value || "").replace(/\D/g, "");
}

export function validateEmploymentRequisites(form) {
    const errors = {};
    Object.entries(REQUISITE_FIELD_RULES).forEach(([name, rule]) => {
        const value = String(form[name] || "").trim();
        if (!value) return;
        if (rule.digits && digitsOnly(value).length !== rule.digits) {
            errors[name] = `${rule.label}: нужно ввести ровно ${rule.digits} цифр (сейчас ${digitsOnly(value).length})`;
        } else if (rule.maxLength && value.length > rule.maxLength) {
            errors[name] = `${rule.label}: допускается не более ${rule.maxLength} символов`;
        }
    });
    const today = new Date().toISOString().slice(0, 10);
    const earliestDate = "1900-01-01";
    if (form.birth_date && form.birth_date < earliestDate) {
        errors.birth_date = "Дата рождения не может быть раньше 01.01.1900";
    }
    if (form.passport_issue_date && form.passport_issue_date < earliestDate) {
        errors.passport_issue_date = "Дата выдачи паспорта не может быть раньше 01.01.1900";
    }
    if (form.birth_date && form.birth_date > today) {
        errors.birth_date = "Дата рождения не может быть в будущем";
    }
    if (form.passport_issue_date && form.passport_issue_date > today) {
        errors.passport_issue_date = "Дата выдачи паспорта не может быть в будущем";
    }
    if (form.birth_date && form.passport_issue_date && form.passport_issue_date < form.birth_date) {
        errors.passport_issue_date = "Дата выдачи паспорта не может быть раньше даты рождения";
    }
    return errors;
}
